export function isNativeAppWrapper(){
  return window.matchMedia('native-app-wrapper')
}
